import { ClientError } from 'graphql-request';
import { DateTime } from 'luxon';
import { DownloadCSVAPIError, APIErrorEnum } from '../types';

export const convertAPIError = (input: any) => {
  return input
    .split('_')
    .map((word: any, index: any) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join('');
};

export const DEFAULT_EXPORT_ORDER_LIMIT = 5000;

export const parseDownloadErrorLimit = (err: ClientError): number => {
  const limit = err?.response?.errors?.[0]?.extensions?.orderLimit;
  return typeof limit === 'number' ? limit : DEFAULT_EXPORT_ORDER_LIMIT;
};

export const parseDownloadErrors = (err: ClientError): DownloadCSVAPIError => {
  const code = err?.response?.errors?.[0]?.extensions?.code as string;
  const exception = err?.response?.errors?.[0]?.extensions?.exception as any;
  if (exception?.status == 429) {
    return 'tooManyRequests' as DownloadCSVAPIError;
  }
  if (Object.values(APIErrorEnum).includes(code)) {
    return convertAPIError(code) as DownloadCSVAPIError;
  }
  return 'default' as DownloadCSVAPIError;
};

export const getDatesDiff = (startDate: string, endDate: string) => {
  const format = 'MM-dd-yyyy';
  const start = DateTime.fromFormat(startDate, format);
  const end = DateTime.fromFormat(endDate, format);

  return end.diff(start, 'days').days + 1;
};
